import { create } from 'react-native-platform-stylesheet';
import i18n from './i18n';

const propertyMap = {
  alignItems: 'alignItems',
  borderLeftWidth: 'borderRightWidth',
  borderRightWidth: 'borderLeftWidth',
  borderLeftColor: 'borderRightColor',
  borderRightColor: 'borderLeftColor',
  justifyContent: 'justifyContent',
  marginLeft: 'marginRight',
  marginRight: 'marginLeft',
  paddingLeft: 'paddingRight',
  paddingRight: 'paddingLeft',
  textAlign: 'textAlign',
  left: 'right',
  right: 'left',
};

const valuesMap = {
  'flex-end': 'flex-start',
  'flex-start': 'flex-end',
  left: 'right',
  right: 'left',
};

// Converts the rtl aware property to the raw stylesheet properties
function setProperty(properties, propertyName, value) {
  if (i18n.rtl()) {
    // Pick up the wanted value in the opposite rtl mode if available
    const mirroredValue = value in valuesMap ? valuesMap[value] : value;
    properties[propertyMap[propertyName]] = mirroredValue;
  } else {
    properties[propertyName] = value;
  }
}

class RtlAwareStyleSheet {
  create(rtlAwareStyles) {
    const styles = {};
    // Looping for each element
    for (let componentStyleName in rtlAwareStyles) {
      styles[componentStyleName] = {};
      // Looping on each property for a given element
      for (let propertyName in rtlAwareStyles[componentStyleName]) {
        if (propertyName === 'rtlAware') {
          // If the element has rtlAware properties, convert them into raw stylesheet properties
          // Looping on each rtlAware property
          for (let rtlAwarePropertyName in rtlAwareStyles[componentStyleName].rtlAware) {
            // Process only if the rtlAware property is mappable into raw stylesheet property
            if (rtlAwarePropertyName in propertyMap) {
              setProperty(
                styles[componentStyleName],
                rtlAwarePropertyName,
                rtlAwareStyles[componentStyleName].rtlAware[rtlAwarePropertyName]
              );
            }
          }
        } else {
          // Else copy the property
          styles[componentStyleName][propertyName] = rtlAwareStyles[componentStyleName][propertyName];
        }
      }
    }

    return create(styles);
  }
}

export default new RtlAwareStyleSheet();
